// removed by extract-text-webpack-plugin
module.exports = {"root":"order-status--root--1YwHy6JB","card-header":"order-status--card-header--3OwUW2Nx order-card--header--1yBG70qV","cardHeader":"order-status--card-header--3OwUW2Nx order-card--header--1yBG70qV","card-body":"order-status--card-body--UCKcjHB9 order-card--body--N03E2PVP","cardBody":"order-status--card-body--UCKcjHB9 order-card--body--N03E2PVP","card-body-refund":"order-status--card-body-refund--2PCaZ5tI","cardBodyRefund":"order-status--card-body-refund--2PCaZ5tI","uploading":"order-status--uploading--1fFYdtpu"};


//////////////////
// WEBPACK FOOTER
// ./views/order-detail/order-status/styles.css
// module id = ./views/order-detail/order-status/styles.css
// module chunks = 0